import React from 'react';
import './MenuCard.css';

const MenuCard = ({ title, icon, id,handleRedirectToModule,value }) => {
  return (
    <div className="menu-card" id={id} onClick={()=>handleRedirectToModule(value)}>
      <div className="card-content">
        <div className="icon-container">
          <img src={icon} alt={`${title} icon`} />
        </div>
        <h3>{title}</h3>
      </div>
    </div>
  );
};

export default MenuCard;